import { service } from '../index.js'

// 推广中心
export const promotion = {
  // 后台：推广设置
  adminSettings: () => {
    return service.get('/promotion/admin/settings')
  },
  // 后台：更新推广设置
  adminUpdateSettings: (data) => {
    return service.post('/promotion/admin/settings', data)
  },
  // 后台：推广用户列表
  adminList: (params) => {
    return service.get('/promotion/admin/list', { params })
  },
  // 后台：佣金列表
  adminEarnings: (params) => {
    return service.get('/promotion/admin/earnings', { params })
  },
  // 后台：结算佣金
  adminSettle: (data) => {
    return service.post('/promotion/admin/settle', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/promotion.js